/// <reference path="../../_ext/Bases/DialogBase.ts" />
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class KaratRateDialog extends _Ext.DialogBase<KaratRateRow, any> {
        protected getFormKey() { return KaratRateForm.formKey; }
        protected getIdProperty() { return KaratRateRow.idProperty; }
        protected getLocalTextPrefix() { return KaratRateRow.localTextPrefix; }
        protected getService() { return KaratRateService.baseUrl; }
        protected getDeletePermission() { return KaratRateRow.deletePermission; }
        protected getInsertPermission() { return KaratRateRow.insertPermission; }
        protected getUpdatePermission() { return KaratRateRow.updatePermission; }
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }
        protected useViewMode() { return true; }
        protected form = new KaratRateForm(this.idPrefix);
        constructor() {
            super();
            q.setTextRightAlign(this.form.FromWt);
            q.setTextRightAlign(this.form.ToWt);
            q.setTextRightAlign(this.form.PurStdRate);
            q.setTextRightAlign(this.form.SaleStdRate);
            this.form.ProductTypeId.changeSelect2(e => {
                //if (this.form.ProductTypeId.value == "11") {
                //    this.form.SubTypeId.cascadeField = "TypeId";
                //    this.form.SubTypeId.cascadeValue = "124";
                 //    this.form.TypeId.value = "124";
                //}
                //if (this.form.ProductTypeId.value == "12") {
                //    this.form.SubTypeId.cascadeField = "TypeId";
                //    this.form.SubTypeId.cascadeValue = "125";
                //    this.form.TypeId.value = "125";
                //}
                this.form.KaratId.cascadeField = "Num1";
                this.form.KaratId.cascadeValue = this.form.ProductTypeId.value;
            });
            this.form.KaratId.changeSelect2(e => {
                if (this.form.ProductTypeId.value == undefined) {
                    Q.alert('Product type not selected');
                    return;
                }
                var atbdetails = AttributeMasterRow.getLookup().itemById[this.form.KaratId.value];
                var metalrate = MetalRateMasterRow.getLookup().items.filter(x => x.MetalTypeId==parseInt(this.form.ProductTypeId.value)).pop();

                this.form.PurStdRate.value = atbdetails.PurchaseFormula * metalrate.Rate;
                this.form.SaleStdRate.value = atbdetails.SalesFormula * metalrate.Rate;
            });
            this.form.SaleStdRate.changeSelect2(e => {
                if (this.form.PurStdRate.value > 0) {
                    if (this.form.SaleStdRate.value > 0 && this.form.SaleStdRate.value < this.form.PurStdRate.value) {
                        Q.warning("Sales Rate can not be less than Purchase Rate");
                        this.form.SaleStdRate.value = 0;
                        this.form.SaleStdRate.element.focus();
                        
                    }
                }
            });

        }
       

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();

            var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");

            var oldDeleteClick = btnDelete.onClick;

            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };




            return btns;
        }

        // #region Edit Delete Validation
        
        private confirmBeforeDelete(oldEvt, e) {
            let self = this;
            //var refid = PriceListDetailsRow.getLookup().items.filter(x => x.AttributeId == this.form.AttributeId.value)[0];
            let refid: PriceListDetailsRow;

            OMS.PriceListDetailsService.GetRate({
                AttributeId: this.form.AttributeId.value
            }, response => {
                if (response.Entities != null && response.Entities.length > 0)
                    refid = response.Entities[0];
            }, { async: false });
            if (refid != null) {
                if (refid.AttributeId != null || refid.AttributeId > 0) {
                    Q.alert("Rate is in use, Cannot delete");
                    return;
                }
            } else {
                KaratRateService.Delete(
                    {
                        EntityId: this.entityId
                    }, response => {
                        Serenity.SubDialogHelper.triggerDataChange(self);
                        self.dialogClose();
                        window.setTimeout(() => Q.notifySuccess(Q.text('Deleted successfully')), 0);
                    });
            }

        }
    }

}